
import React from 'react';
import { GL_WELL_STATUS_ROWS } from '../../constants/latest-asset-trend.constant';
import GenericGlWidget from './GenericGlWidget';

const GlWellEquipmentStatusWidget: React.FC = () => {
  return <GenericGlWidget title='Status' rowsConfig={GL_WELL_STATUS_ROWS} />;
};

export default GlWellEquipmentStatusWidget;
